"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _layout = require("../../layout");

var _context = require("../../context");

var _propTypes = require("../../prop-types");

var _PageContainer = require("../PageContainer");

var _constants = require("./constants");

var HeaderRow = _layout.View.withComponent('header', {
  target: "emwj0d80"
});

var PageHeaderDefaultProps = {
  fullWidth: false,
  hasShadow: false,
  fixed: false,
  top: 0
};

var PageHeaderBase = function PageHeaderBase(_ref) {
  var children = _ref.children,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? PageHeaderDefaultProps.fullWidth : _ref$fullWidth,
      _ref$hasShadow = _ref.hasShadow,
      hasShadow = _ref$hasShadow === void 0 ? PageHeaderDefaultProps.hasShadow : _ref$hasShadow,
      _ref$fixed = _ref.fixed,
      fixed = _ref$fixed === void 0 ? PageHeaderDefaultProps.fixed : _ref$fixed,
      dataTestId = _ref.dataTestId,
      _ref$top = _ref.top,
      top = _ref$top === void 0 ? PageHeaderDefaultProps.top : _ref$top;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: 'StencilReactPageHeader',
    dataTestId: dataTestId
  });
  var height = selectors.constant('headerHeight');
  var wrapperCss = (0, _react.useMemo)(function () {
    return (
      /*#__PURE__*/
      (0, _core.css)((0, _objectSpread2.default)({
        top: top,
        left: 0,
        boxShadow: hasShadow ? "0px 0px 10px ".concat((0, _utils.opacify)(selectors.color(_constants.PAGE_HEADER_BACKGROUND_COLOR), 0.2)) : 'none'
      }, fixed ? {
        position: 'fixed',
        zIndex: selectors.zIndex('header')
      } : {}), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    );
  }, [hasShadow, fixed, selectors, top]);
  return (0, _core.jsx)(_layout.View, {
    margin: {
      top: top
    }
  }, (0, _core.jsx)(HeaderRow, (0, _extends2.default)({}, dataTestProps, {
    css: wrapperCss,
    height: height,
    alignItems: "center",
    width: "100%",
    backgroundColor: _constants.PAGE_HEADER_BACKGROUND_COLOR
  }), (0, _core.jsx)(_PageContainer.PageContainer, {
    paddingBottom: "0",
    paddingTop: "0",
    display: "flex",
    height: "100%",
    alignItems: "center",
    fullWidth: fullWidth
  }, children)), fixed && (0, _core.jsx)(_layout.Spacer, {
    height: height
  }));
};

var PageHeader = (0, _stencilReactDesc.describe)(PageHeaderBase).description('Page header with base functionality.');
exports.PageHeader = PageHeader;
PageHeader.displayName = 'PageHeader';
PageHeader.defaultProps = PageHeaderDefaultProps;
PageHeader.propTypes = {
  top: (0, _propTypes.cssValue)().description('Sets the spacing from the top, especially useful when "fixed" is true.'),
  hasShadow: _stencilReactDesc.PropTypes.bool.description('Determines whether to render a shadow.'),
  fixed: _stencilReactDesc.PropTypes.bool.description('Determines whether to fix the header to the top of the page.'),
  fullWidth: _stencilReactDesc.PropTypes.bool.description("Determines whether to ignore theme's maxWidth and apply full width.")
};